import { createQueryKeys } from "@lukemorales/query-key-factory";

import { getCredit } from "./credit";

export const referralQueriesStore = createQueryKeys("referral", {
  credit: {
    queryKey: null,
    queryFn: getCredit,
  },
});
